import { render, staticRenderFns } from "./LowerPrice.vue?vue&type=template&id=4e24f230&"
import script from "./LowerPrice.vue?vue&type=script&lang=js&"
export * from "./LowerPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports